/**
 * 画面の読み込みの失敗（03 3.7.2）：本文の位置に Alert（error）＋「再読み込み」＋trace_id（押すとコピー。要件書 NFR-13）。
 */
import { Alert, Box, Button, Typography } from '@mui/material';

export function TraceIdText({ trace_id }: { trace_id: string | undefined }) {
  if (!trace_id) {
    return null;
  }
  return (
    <Typography
      component="button"
      type="button"
      variant="caption"
      onClick={() => void navigator.clipboard?.writeText(trace_id).catch(() => undefined)}
      sx={{ fontFamily: 'monospace', border: 0, background: 'none', p: 0, cursor: 'copy', color: 'text.secondary' }}
      aria-label="trace_id をコピー"
    >
      trace_id: {trace_id}
    </Typography>
  );
}

export function ErrorPanel(props: { message: string; trace_id?: string; onRetry?: () => void }) {
  return (
    <Box sx={{ p: { xs: 1.5, md: 3 } }}>
      <Alert
        severity="error"
        action={
          props.onRetry ? (
            <Button color="inherit" size="small" onClick={props.onRetry}>
              再読み込み
            </Button>
          ) : undefined
        }
      >
        <Box>{props.message}</Box>
        <TraceIdText trace_id={props.trace_id} />
      </Alert>
    </Box>
  );
}
